export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  GenericScalar: any;
  JSONString: string;
  UUID: any;
};









export type AcceptCareRecommendationMutation = {
  __typename?: 'AcceptCareRecommendationMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export enum AccountOnboardingStatus {
  Ineligible = 'INELIGIBLE',
  Eligible = 'ELIGIBLE',
  Active = 'ACTIVE',
  Deprovisioned = 'DEPROVISIONED',
  Unmatchable = 'UNMATCHABLE'
}

export enum AccountProviderSchedulingType {
  Calendar = 'CALENDAR',
  Roster = 'ROSTER',
  MaximumMembers = 'MAXIMUM_MEMBERS',
  NotSet = 'NOT_SET'
}

export enum AccountRole {
  SystemAdministrator = 'SYSTEM_ADMINISTRATOR',
  PowerUser = 'POWER_USER',
  Coach = 'COACH',
  Member = 'MEMBER',
  GroupPractice = 'GROUP_PRACTICE'
}

export type AddCoachMutation = {
  __typename?: 'AddCoachMutation';
  coachAssignment?: Maybe<CoachAssignmentNode>;
};

export type AddMemberCarePreferenceMutation = {
  __typename?: 'AddMemberCarePreferenceMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type AddNoteMutation = {
  __typename?: 'AddNoteMutation';
  note?: Maybe<NoteNode>;
};

export type AddSymptomsExperiencedMutation = {
  __typename?: 'AddSymptomsExperiencedMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type AnswerCustomOptions = {
  __typename?: 'AnswerCustomOptions';
  title?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
};

export type AnswerOption = {
  __typename?: 'AnswerOption';
  text?: Maybe<Scalars['String']>;
  customOptions?: Maybe<AnswerCustomOptions>;
  customOptionValue?: Maybe<Scalars['String']>;
  isSelected?: Maybe<Scalars['Boolean']>;
};

export type AssessmentAnswerNode = {
  __typename?: 'AssessmentAnswerNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  answerOrder: Scalars['Int'];
  value: Scalars['Int'];
  answerText: Scalars['String'];
  answerTextEnUs?: Maybe<Scalars['String']>;
  answerTextEs?: Maybe<Scalars['String']>;
  answerTextFrCa?: Maybe<Scalars['String']>;
  answerTextFr?: Maybe<Scalars['String']>;
  answerTextKo?: Maybe<Scalars['String']>;
  answerTextJa?: Maybe<Scalars['String']>;
  answerTextZhHans?: Maybe<Scalars['String']>;
  answerTextDe?: Maybe<Scalars['String']>;
  answerTextHi?: Maybe<Scalars['String']>;
  answerTextPt?: Maybe<Scalars['String']>;
  questions: Array<AssessmentQuestionNode>;
};

export type AssessmentFlowNode = {
  __typename?: 'AssessmentFlowNode';
  member: MemberNode;
  careRecommendation?: Maybe<CareRecommendationNode>;
  uuid: Scalars['UUID'];
  startedAt: Scalars['DateTime'];
};

export type AssessmentNode = {
  __typename?: 'AssessmentNode';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  calculation: Scalars['String'];
  mandatory: Scalars['Boolean'];
  questions?: Maybe<Scalars['JSONString']>;
  resources?: Maybe<Array<Maybe<Scalars['String']>>>;
  headerText?: Maybe<Scalars['String']>;
  englishOnlyHeaderText?: Maybe<Scalars['String']>;
  assessmentQuestions: Array<AssessmentQuestionNode>;
};

export type AssessmentQuestionNode = {
  __typename?: 'AssessmentQuestionNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  questionOrder: Scalars['Int'];
  questionKey: Scalars['String'];
  questionText: Scalars['String'];
  responseType: Array<AssessmentAnswerNode>;
  optional: Scalars['Boolean'];
  displayCrisisWarning: Scalars['Boolean'];
};

export type AvailableHourInput = {
  day: Scalars['String'];
  start: Scalars['String'];
  end: Scalars['String'];
};

export type AvailableHourNode = {
  __typename?: 'AvailableHourNode';
  day?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
};

export type AvailablePeriodNode = {
  __typename?: 'AvailablePeriodNode';
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
};

export type AvailableReportType = {
  __typename?: 'AvailableReportType';
  reportOrSectionEnum?: Maybe<Scalars['String']>;
  lookerUrl?: Maybe<Scalars['String']>;
  lookerUrlTtl?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
};

export type AvailableSectionType = {
  __typename?: 'AvailableSectionType';
  reportOrSectionEnum?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  reports?: Maybe<Array<Maybe<PossibleReportType>>>;
};

export type BaseError = {
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type CalendarAuthLinkNode = {
  __typename?: 'CalendarAuthLinkNode';
  url?: Maybe<Scalars['String']>;
  alreadyConnected?: Maybe<Scalars['Boolean']>;
};

export type CalendarNode = {
  __typename?: 'CalendarNode';
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  calendarProfile: CalendarProfileNode;
  isActive: Scalars['Boolean'];
  isTarget: Scalars['Boolean'];
  isReadonly: Scalars['Boolean'];
  calendarName: Scalars['String'];
};

export type CalendarProfileNode = {
  __typename?: 'CalendarProfileNode';
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  providerName: Scalars['String'];
  profileId: Scalars['String'];
  profileName: Scalars['String'];
  calendars: Array<CalendarNode>;
};

export type CancelEventMutation = {
  __typename?: 'CancelEventMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum CareOption {
  DigitalPrograms = 'DIGITAL_PROGRAMS',
  Circles = 'CIRCLES',
  Therapy = 'THERAPY',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING',
  Coaching = 'COACHING'
}

export enum CareRecommendationModality {
  Unspecified = 'UNSPECIFIED',
  OnMyOwn = 'ON_MY_OWN',
  WithASmallGroup = 'WITH_A_SMALL_GROUP',
  OneOnOne = 'ONE_ON_ONE'
}

export enum CareRecommendationModalityPreference {
  Unspecified = 'UNSPECIFIED',
  OnMyOwn = 'ON_MY_OWN',
  WithASmallGroup = 'WITH_A_SMALL_GROUP',
  OneOnOne = 'ONE_ON_ONE'
}

export type CareRecommendationNode = {
  __typename?: 'CareRecommendationNode';
  uuid: Scalars['UUID'];
  member: MemberNode;
  calculatedUsingContentResponses?: Maybe<ContentResponsesNode>;
  modalityPreference?: Maybe<CareRecommendationModalityPreference>;
  recommendation?: Maybe<CareRecommendationRecommendation>;
  outcome?: Maybe<CareRecommendationOutcome>;
  state: CareRecommendationState;
  startedAt: Scalars['DateTime'];
  recommendedAt?: Maybe<Scalars['DateTime']>;
  acceptedAt?: Maybe<Scalars['DateTime']>;
  onboarding: Scalars['Boolean'];
  topicSelections: Array<TopicSelectionNode>;
};

export enum CareRecommendationOutcome {
  DigitalPrograms = 'DIGITAL_PROGRAMS',
  Circles = 'CIRCLES',
  Therapy = 'THERAPY',
  Coaching = 'COACHING',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING'
}

export enum CareRecommendationRecommendation {
  DigitalPrograms = 'DIGITAL_PROGRAMS',
  Circles = 'CIRCLES',
  Therapy = 'THERAPY',
  Coaching = 'COACHING',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING'
}

export enum CareRecommendationState {
  Started = 'STARTED',
  TopicsSelected = 'TOPICS_SELECTED',
  SymptomsSelected = 'SYMPTOMS_SELECTED',
  PrimaryFocusSelected = 'PRIMARY_FOCUS_SELECTED',
  DifficultySelected = 'DIFFICULTY_SELECTED',
  ModalitySelected = 'MODALITY_SELECTED',
  AssessmentsCompleted = 'ASSESSMENTS_COMPLETED',
  Recommended = 'RECOMMENDED',
  Accepted = 'ACCEPTED'
}

export type CertificationNode = {
  __typename?: 'CertificationNode';
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  certificationRequirements: Array<CertificationRequirementNode>;
};

export enum CertificationRequirementCareOption {
  DigitalPrograms = 'DIGITAL_PROGRAMS',
  Circles = 'CIRCLES',
  Therapy = 'THERAPY',
  Coaching = 'COACHING',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING'
}

export type CertificationRequirementNode = {
  __typename?: 'CertificationRequirementNode';
  uuid: Scalars['UUID'];
  certification: CertificationNode;
  careOption: CertificationRequirementCareOption;
  description: Scalars['String'];
  isActive: Scalars['Boolean'];
};

export type ChooseProviderMutation = {
  __typename?: 'ChooseProviderMutation';
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
};

export type CircleBaseQuestion = {
  id: Scalars['ID'];
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleFacilitatorNode = Node & {
  __typename?: 'CircleFacilitatorNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  credential: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
};

export type CircleFreeResponseQuestion = CircleBaseQuestion & {
  __typename?: 'CircleFreeResponseQuestion';
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  questionText: Scalars['String'];
  maxLength?: Maybe<Scalars['Int']>;
};

export type CircleMultipleChoiceOption = Node & {
  __typename?: 'CircleMultipleChoiceOption';
  id: Scalars['ID'];
  optionText: Scalars['String'];
  optionValue?: Maybe<Scalars['Int']>;
};

export type CircleMultipleChoiceQuestion = CircleBaseQuestion & {
  __typename?: 'CircleMultipleChoiceQuestion';
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  questionText: Scalars['String'];
  options: Array<Maybe<CircleMultipleChoiceOption>>;
};

export type CircleQuestion = CircleMultipleChoiceQuestion | CircleFreeResponseQuestion;

export type CircleRsvp = Node & {
  __typename?: 'CircleRsvp';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  attendeeUuid: Scalars['UUID'];
  session: CircleSessionNode;
  state: CircleRsvpState;
  createdAt: Scalars['DateTime'];
  cancelledAt?: Maybe<Scalars['DateTime']>;
  answers: Array<CircleSessionRsvpAnswer>;
};

export type CircleRsvpAnswerInput = {
  questionId: Scalars['ID'];
  answer?: Maybe<Scalars['String']>;
  optionId?: Maybe<Scalars['ID']>;
};

export type CircleRsvpResponsePayload = {
  __typename?: 'CircleRsvpResponsePayload';
  ok?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  rsvpUuid?: Maybe<Scalars['UUID']>;
};

export enum CircleRsvpState {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  None = 'NONE'
}

export type CircleSeriesCollection = {
  __typename?: 'CircleSeriesCollection';
  items: Array<Maybe<CircleSeriesNode>>;
  totalCount: Scalars['Int'];
};

export type CircleSeriesLinkNode = Node & {
  __typename?: 'CircleSeriesLinkNode';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['UUID']>;
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  circleSeries?: Maybe<CircleSeriesNode>;
};

export type CircleSeriesNode = Node & {
  __typename?: 'CircleSeriesNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  description: Scalars['String'];
  shortDescription: Scalars['String'];
  illustration?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  topics: CircleTopicConnection;
};


export type CircleSeriesNodeTopicsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export enum CircleSessionBookingStatus {
  FullyBooked = 'FULLY_BOOKED',
  LimitedAvailability = 'LIMITED_AVAILABILITY',
  SpotsAvailable = 'SPOTS_AVAILABLE',
  ManySpotsAvailable = 'MANY_SPOTS_AVAILABLE'
}

export type CircleSessionConnection = {
  __typename?: 'CircleSessionConnection';
  edges: Array<Maybe<CircleSessionEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleSessionEdge = {
  __typename?: 'CircleSessionEdge';
  cursor: Scalars['String'];
  node: CircleSessionNode;
};

export type CircleSessionLinkNode = Node & {
  __typename?: 'CircleSessionLinkNode';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['UUID']>;
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  circleSession?: Maybe<CircleSessionNode>;
};

export type CircleSessionNode = Node & {
  __typename?: 'CircleSessionNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  topic: CircleTopicNode;
  startTime: Scalars['DateTime'];
  facilitators: Array<Maybe<CircleFacilitatorNode>>;
  seatLimit: Scalars['Int'];
  seatsLeft?: Maybe<Scalars['Int']>;
  bookingStatus?: Maybe<CircleSessionBookingStatus>;
  rsvpLink: Scalars['String'];
};

export type CircleSessionRsvpAnswer = {
  __typename?: 'CircleSessionRsvpAnswer';
  questionId: Scalars['ID'];
  answer: Scalars['String'];
};

export type CircleTopicConnection = {
  __typename?: 'CircleTopicConnection';
  edges: Array<Maybe<CircleTopicEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleTopicEdge = {
  __typename?: 'CircleTopicEdge';
  cursor: Scalars['String'];
  node: CircleTopicNode;
};

export enum CircleTopicFormat {
  Workshop = 'WORKSHOP',
  ListenAndLearn = 'LISTEN_AND_LEARN',
  Fireside = 'FIRESIDE',
  Discussion = 'DISCUSSION'
}

export type CircleTopicLinkNode = Node & {
  __typename?: 'CircleTopicLinkNode';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['UUID']>;
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  circleTopic?: Maybe<CircleTopicNode>;
};

export type CircleTopicNode = Node & {
  __typename?: 'CircleTopicNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  series: CircleSeriesNode;
  name: Scalars['String'];
  description: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  format: CircleTopicFormat;
  duration: Scalars['Int'];
  slug: Scalars['String'];
  questions: Array<Maybe<CircleQuestion>>;
  sessions: CircleSessionConnection;
};


export type CircleTopicNodeSessionsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  afterDateTime?: Maybe<Scalars['DateTime']>;
  beforeDateTime?: Maybe<Scalars['DateTime']>;
};

export type ClientSummaryNode = Node & {
  __typename?: 'ClientSummaryNode';
  memberName: Scalars['String'];
  memberFirstName: Scalars['String'];
  memberLastName: Scalars['String'];
  memberEmail: Scalars['String'];
  memberUuid: Scalars['UUID'];
  companyName: Scalars['String'];
  lastVisit?: Maybe<Scalars['DateTime']>;
  nextVisit?: Maybe<Scalars['DateTime']>;
  visitsUsed: Scalars['Int'];
  visitsCovered: Scalars['Int'];
  visitsRemaining: Scalars['Int'];
  lastWho5Score?: Maybe<Scalars['Int']>;
  appInstalled: Scalars['Boolean'];
  id: Scalars['ID'];
  matchStatus?: Maybe<Scalars['String']>;
  coachAssignment?: Maybe<CoachAssignmentNode>;
};

export type ClientSummaryNodeConnection = {
  __typename?: 'ClientSummaryNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ClientSummaryNodeEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ClientSummaryNodeEdge = {
  __typename?: 'ClientSummaryNodeEdge';
  node?: Maybe<ClientSummaryNode>;
  cursor: Scalars['String'];
};

export type CoachAssignmentNode = {
  __typename?: 'CoachAssignmentNode';
  uuid: Scalars['UUID'];
  coach?: Maybe<CoachNode>;
  createdAt: Scalars['DateTime'];
  active: Scalars['Boolean'];
  inactiveAt?: Maybe<Scalars['DateTime']>;
  coachingVisits: Array<CoachingVisitNode>;
  conversation?: Maybe<ConversationNode>;
  member?: Maybe<MemberNode>;
  intakeForm?: Maybe<IntakeFormNode>;
};

export type CoachNode = {
  __typename?: 'CoachNode';
  uuid: Scalars['UUID'];
  avatar?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  localTimezone?: Maybe<Scalars['String']>;
  credentials?: Maybe<Scalars['String']>;
  introduction?: Maybe<Scalars['String']>;
  providerSchedulingType?: Maybe<AccountProviderSchedulingType>;
  officeHours?: Maybe<Scalars['GenericScalar']>;
  newClientCapacity?: Maybe<Scalars['Int']>;
  providerType?: Maybe<Scalars['String']>;
  providerInvoicingOnly?: Maybe<Scalars['Boolean']>;
  providerSpecialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  therapistModalities?: Maybe<Array<Maybe<Scalars['String']>>>;
  bufferTime?: Maybe<Scalars['Int']>;
  lateCancellationThreshold?: Maybe<Scalars['Int']>;
  defaultVisitDuration?: Maybe<Scalars['Int']>;
  maximumMemberSlots?: Maybe<Scalars['Int']>;
  races: Array<Maybe<Scalars['String']>>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  languagePreferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  licensedStates?: Maybe<Array<Maybe<Scalars['String']>>>;
  providerCertifications: Array<ProviderCertificationNode>;
  goalInterests?: Maybe<Array<Maybe<Scalars['String']>>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  languagePreference?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  matchScore?: Maybe<Scalars['Float']>;
  matchAlgorithmVersion?: Maybe<Scalars['String']>;
  isInAppProvider?: Maybe<Scalars['Boolean']>;
  preferencesMatched?: Maybe<Array<Maybe<MemberFilterPreferenceNode>>>;
  providerNextAvailability?: Maybe<Scalars['String']>;
};


export type CoachNodePreferencesMatchedArgs = {
  preferences: MemberPreferencesInput;
};

export enum CoachingVisitModalityType {
  Video = 'VIDEO',
  Phone = 'PHONE',
  InPerson = 'IN_PERSON',
  Unknown = 'UNKNOWN'
}

export type CoachingVisitNode = {
  __typename?: 'CoachingVisitNode';
  uuid: Scalars['UUID'];
  coachAssignment?: Maybe<CoachAssignmentNode>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  actualDuration?: Maybe<Scalars['Int']>;
  scheduledTime: Scalars['DateTime'];
  isTherapy: Scalars['Boolean'];
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  visitInfo?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  state: CoachingVisitState;
  modalityType: CoachingVisitModalityType;
  videoService?: Maybe<Scalars['String']>;
  providerVideoStartTime?: Maybe<Scalars['DateTime']>;
  providerVideoEndTime?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<Scalars['String']>;
  videoSessionUrl?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
  coachUuid?: Maybe<Scalars['String']>;
  zoomUrl?: Maybe<Scalars['String']>;
  rating?: Maybe<RatingNode>;
  reviews?: Maybe<Array<Maybe<ReviewNode>>>;
  previousProviderReview?: Maybe<CoachingVisitProviderReviewNode>;
  lastTokboxActivity?: Maybe<Scalars['DateTime']>;
  lastZoomActivity?: Maybe<Scalars['DateTime']>;
};

export type CoachingVisitProviderReviewNode = {
  __typename?: 'CoachingVisitProviderReviewNode';
  feedbackText?: Maybe<Scalars['String']>;
  abilityToHelpClient: Scalars['Int'];
  workedOnAgreedUponGoals: Scalars['Int'];
  clearPlanToWorkTowardGoals: Scalars['Int'];
};

export enum CoachingVisitState {
  Scheduled = 'SCHEDULED',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
  LateCancellation = 'LATE_CANCELLATION',
  NoShow = 'NO_SHOW',
  CompletedCredited = 'COMPLETED_CREDITED',
  Unknown = 'UNKNOWN',
  Attended = 'ATTENDED'
}

export type CompanyAdditionalBenefitNode = {
  __typename?: 'CompanyAdditionalBenefitNode';
  id: Scalars['ID'];
  title: Scalars['String'];
  titleEnUs?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFrCa?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleKo?: Maybe<Scalars['String']>;
  titleJa?: Maybe<Scalars['String']>;
  titleZhHans?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleHi?: Maybe<Scalars['String']>;
  titlePt?: Maybe<Scalars['String']>;
  link: Scalars['String'];
  description: Scalars['String'];
  descriptionEnUs?: Maybe<Scalars['String']>;
  descriptionEs?: Maybe<Scalars['String']>;
  descriptionFrCa?: Maybe<Scalars['String']>;
  descriptionFr?: Maybe<Scalars['String']>;
  descriptionKo?: Maybe<Scalars['String']>;
  descriptionJa?: Maybe<Scalars['String']>;
  descriptionZhHans?: Maybe<Scalars['String']>;
  descriptionDe?: Maybe<Scalars['String']>;
  descriptionHi?: Maybe<Scalars['String']>;
  descriptionPt?: Maybe<Scalars['String']>;
  company: CompanyDropdownNode;
  country?: Maybe<CountryNode>;
  isGlobal?: Maybe<Scalars['Boolean']>;
};

export type CompanyDropdownNode = {
  __typename?: 'CompanyDropdownNode';
  name: Scalars['String'];
  id: Scalars['ID'];
};

export type CompanyNode = {
  __typename?: 'CompanyNode';
  name: Scalars['String'];
  coveredCoachingVisits: Scalars['Int'];
  coveredTherapyVisits: Scalars['Int'];
  resetDate: Scalars['Date'];
  specificInfo?: Maybe<Scalars['String']>;
  dependentInvitationFeature: Scalars['Boolean'];
  maximumNumberOfDependents: Scalars['Int'];
  minimumDependentTherapyAge: Scalars['Int'];
  hrEmail?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
};

export enum ContentCollectionLinkLinkType {
  Program = 'PROGRAM',
  Meditation = 'MEDITATION',
  InternalLink = 'INTERNAL_LINK',
  ExternalLink = 'EXTERNAL_LINK',
  CircleTopic = 'CIRCLE_TOPIC',
  CircleSeries = 'CIRCLE_SERIES',
  CircleSession = 'CIRCLE_SESSION'
}

export type ContentCollectionNode = {
  __typename?: 'ContentCollectionNode';
  id: Scalars['ID'];
  scheduledContent?: Maybe<ScheduledContentNode>;
  uuid: Scalars['UUID'];
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  contentCollectionLinks: Array<Maybe<ContentLinkNode>>;
};

export enum ContentCollectionPlatform {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export enum ContentCollectionRenderComponent {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL',
  Banner = 'BANNER'
}

export type ContentLinkNode = ProgramLinkNode | MeditationLinkNode | InternalLinkNode | ExternalLinkNode | CircleTopicLinkNode | CircleSeriesLinkNode | CircleSessionLinkNode | ScreenLinkNode;

export type ContentResponsesNode = {
  __typename?: 'ContentResponsesNode';
  id: Scalars['ID'];
  account: MemberNode;
  assessmentFlow?: Maybe<AssessmentFlowNode>;
  assessment?: Maybe<AssessmentNode>;
  timestamp: Scalars['DateTime'];
  content?: Maybe<Scalars['JSONString']>;
  delta?: Maybe<Scalars['JSONString']>;
  careRecommendation: Array<CareRecommendationNode>;
  member?: Maybe<MemberNode>;
};

export enum ConversationKind {
  Coaching = 'COACHING',
  Therapy = 'THERAPY',
  LiveCoaching = 'LIVE_COACHING'
}

export type ConversationNode = Node & {
  __typename?: 'ConversationNode';
  uuid?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  coach?: Maybe<MemberNode>;
  member?: Maybe<MemberNode>;
  active: Scalars['Boolean'];
  inactiveAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  kind?: Maybe<ConversationKind>;
  messages?: Maybe<MessageNodeConnection>;
  newestMessage?: Maybe<MessageNode>;
  myNewestMessage?: Maybe<MessageNode>;
  isNewMatch?: Maybe<Scalars['Boolean']>;
  isMatchedOverFiveDaysAgo?: Maybe<Scalars['Boolean']>;
  oldMatchNotContacted?: Maybe<Scalars['Boolean']>;
  oldestMessage?: Maybe<MessageNode>;
  provider?: Maybe<CoachNode>;
};


export type ConversationNodeMessagesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['UUID']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  senderUuid?: Maybe<Scalars['UUID']>;
  receiverUuid?: Maybe<Scalars['UUID']>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  orderBy?: Maybe<Scalars['String']>;
};

export type ConversationNodeConnection = {
  __typename?: 'ConversationNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ConversationNodeEdge>>;
};

export type ConversationNodeEdge = {
  __typename?: 'ConversationNodeEdge';
  node?: Maybe<ConversationNode>;
  cursor: Scalars['String'];
};

export type CountryNode = {
  __typename?: 'CountryNode';
  name: Scalars['String'];
};

export type CptCodeNode = {
  __typename?: 'CptCodeNode';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
};

export type CreateCoachingVisitMemberReviewMutation = {
  __typename?: 'CreateCoachingVisitMemberReviewMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateCoachingVisitMutation = {
  __typename?: 'CreateCoachingVisitMutation';
  /** @deprecated Please use the formatted_response field */
  ok?: Maybe<Scalars['Boolean']>;
  /** @deprecated Please use the formatted_response field */
  uuid?: Maybe<Scalars['UUID']>;
  formattedResponse?: Maybe<CreateCoachingVisitOutput>;
};

export type CreateCoachingVisitOutput = CreateCoachingVisitResult | ExpectedError;

export type CreateCoachingVisitResult = {
  __typename?: 'CreateCoachingVisitResult';
  ok?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type CreateConversationMutation = {
  __typename?: 'CreateConversationMutation';
  conversation?: Maybe<ConversationNode>;
};

export type CreateEligibilityCheckResponse = {
  __typename?: 'CreateEligibilityCheckResponse';
  ok: Scalars['Boolean'];
  errors?: Maybe<Scalars['String']>;
  eligibilityCheck?: Maybe<EligibilityCheckNode>;
};

export type CreateEventFormattedResponse = CreateEventResult | ExpectedError;

export type CreateEventMutation = {
  __typename?: 'CreateEventMutation';
  /** @deprecated Please use the formatted_response field */
  ok?: Maybe<Scalars['Boolean']>;
  /** @deprecated Please use the formatted_response field */
  uuid?: Maybe<Scalars['UUID']>;
  formattedResponse?: Maybe<CreateEventFormattedResponse>;
};

export type CreateEventResult = {
  __typename?: 'CreateEventResult';
  ok?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type CreateNotificationMutation = {
  __typename?: 'CreateNotificationMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateOrUpdateInsuranceInput = {
  insurance?: Maybe<InsuranceInput>;
  employerInsurance?: Maybe<EmployerInsuranceInput>;
};

export type CreateOrUpdateInsuranceMemberInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender: Scalars['String'];
  dateOfBirth: Scalars['DateTime'];
  address: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
};

export type CreateOrUpdateInsuranceMemberResponse = {
  __typename?: 'CreateOrUpdateInsuranceMemberResponse';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  insuranceMember?: Maybe<InsuranceMemberNode>;
};

export type CreateOrUpdateInsuranceResponse = {
  __typename?: 'CreateOrUpdateInsuranceResponse';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  insurance?: Maybe<InsuranceNode>;
};

export type CreateOrUpdateProviderReview = {
  __typename?: 'CreateOrUpdateProviderReview';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateProviderReview = {
  __typename?: 'CreateProviderReview';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateTestMember = {
  __typename?: 'CreateTestMember';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateVisitMutation = {
  __typename?: 'CreateVisitMutation';
  ok?: Maybe<Scalars['Boolean']>;
  coachingVisitUuid?: Maybe<Scalars['UUID']>;
};

export type CrisisProviderCompanyAssignmentNode = {
  __typename?: 'CrisisProviderCompanyAssignmentNode';
  id: Scalars['ID'];
  crisisProvider: CrisisProviderNode;
  company: CompanyDropdownNode;
  isActive: Scalars['Boolean'];
};

export type CrisisProviderCountryAssignmentNode = {
  __typename?: 'CrisisProviderCountryAssignmentNode';
  id: Scalars['ID'];
  crisisProvider: CrisisProviderNode;
  country: CountryNode;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type CrisisProviderNode = {
  __typename?: 'CrisisProviderNode';
  name: Scalars['String'];
  defaultPhoneNumber?: Maybe<Scalars['String']>;
};



export type DeleteCalendarProfileMutation = {
  __typename?: 'DeleteCalendarProfileMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteTestMember = {
  __typename?: 'DeleteTestMember';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum DifficultyAgreement {
  StronglyDisagree = 'STRONGLY_DISAGREE',
  Disagree = 'DISAGREE',
  NeitherDisagreeOrAgree = 'NEITHER_DISAGREE_OR_AGREE',
  Agree = 'AGREE',
  StronglyAgree = 'STRONGLY_AGREE'
}

export type DisableHrAdminMutationResult = DisableHrAdminSuccessOutput | UnknownHrAdminError | PermissionDeniedError;

export type DisableHrAdminSuccessOutput = {
  __typename?: 'DisableHRAdminSuccessOutput';
  ok?: Maybe<Scalars['Boolean']>;
  hrAdmin?: Maybe<HrAdminNode>;
};

export type DxCodeNode = {
  __typename?: 'DxCodeNode';
  code?: Maybe<Scalars['String']>;
  dsm?: Maybe<Scalars['String']>;
  primaryGroup?: Maybe<Scalars['String']>;
  secondaryGroup?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type EligibilityCheckNode = {
  __typename?: 'EligibilityCheckNode';
  isEligible: Scalars['Boolean'];
};

export type EligiblePersonNode = {
  __typename?: 'EligiblePersonNode';
  company?: Maybe<CompanyDropdownNode>;
  uuid: Scalars['UUID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  ineligible: Scalars['Boolean'];
};

export type EmployerInsuranceInput = {
  companyUuid: Scalars['UUID'];
  employerInsuranceId?: Maybe<Scalars['String']>;
  policyNumber?: Maybe<Scalars['String']>;
};

export type EmployerInsuranceNode = {
  __typename?: 'EmployerInsuranceNode';
  name?: Maybe<Scalars['String']>;
};

export type ExpectedError = {
  __typename?: 'ExpectedError';
  debug?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type ExternalLinkNode = Node & {
  __typename?: 'ExternalLinkNode';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['UUID']>;
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  title: Scalars['String'];
  subtitle: Scalars['String'];
  image: Scalars['String'];
};

export type FeatureRecordDoesNotExist = {
  __typename?: 'FeatureRecordDoesNotExist';
  name?: Maybe<Scalars['String']>;
};

export type FeatureRecordReviewInput = {
  isUseful?: Maybe<Scalars['Boolean']>;
  feedbackText?: Maybe<Scalars['String']>;
  featureRecordName: Scalars['String'];
};

export type FeatureRecordReviewResponse = {
  __typename?: 'FeatureRecordReviewResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum FeelingsAboutTherapyEnum {
  Committed = 'COMMITTED',
  Neutral = 'NEUTRAL',
  Hesitant = 'HESITANT'
}


export type GetAllReportsAndSectionsResult = GetAllReportsAndSectionsSuccessResult | PermissionDeniedError;

export type GetAllReportsAndSectionsSuccessResult = {
  __typename?: 'GetAllReportsAndSectionsSuccessResult';
  reportsOrSections?: Maybe<Array<Maybe<PossibleReportAndSectionType>>>;
};

export type GetOrCreateCoachingVisitVideoSessionMutation = {
  __typename?: 'GetOrCreateCoachingVisitVideoSessionMutation';
  videoSession?: Maybe<VideoSessionNode>;
};

export type GroupPracticeNode = {
  __typename?: 'GroupPracticeNode';
  uuid: Scalars['UUID'];
  providers?: Maybe<Array<Maybe<CoachNode>>>;
};

export type HrAdminNode = {
  __typename?: 'HRAdminNode';
  uuid: Scalars['UUID'];
  disabledAt?: Maybe<Scalars['DateTime']>;
  isModernHealthCsm: Scalars['Boolean'];
  eligiblePersons?: Maybe<Array<Maybe<EligiblePersonNode>>>;
};

export type HrAdminResult = {
  __typename?: 'HRAdminResult';
  results?: Maybe<Array<Maybe<HrAdminNode>>>;
};

export type HrisAppInfo = {
  appName: Scalars['String'];
  appUuid: Scalars['UUID'];
};

export type HrisAuthInfo = {
  accessToken: Scalars['String'];
};

export type HrisConnectionNode = {
  __typename?: 'HRISConnectionNode';
  uuid: Scalars['UUID'];
  createdTime: Scalars['DateTime'];
  hrAdmin?: Maybe<HrAdminNode>;
  appName: Scalars['String'];
  appUuid: Scalars['UUID'];
  disabledAt?: Maybe<Scalars['DateTime']>;
};

export type HrMessageNode = {
  __typename?: 'HRMessageNode';
  uuid: Scalars['UUID'];
  companyUuid: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  contentLinks?: Maybe<Array<Maybe<HrMonitorContentLinkNode>>>;
};

export type HrMessages = {
  __typename?: 'HRMessages';
  results?: Maybe<Array<Maybe<HrMessageNode>>>;
};

export type HrMessagesResult = HrMessages | PermissionDeniedError;

export type HrMonitorContentLinkNode = {
  __typename?: 'HRMonitorContentLinkNode';
  webValue?: Maybe<Scalars['String']>;
  bannerContent: Scalars['String'];
  bannerCtaText: Scalars['String'];
  accentColor?: Maybe<Scalars['String']>;
  titleColor?: Maybe<Scalars['String']>;
  bannerTitle?: Maybe<Scalars['String']>;
  bannerSubtitle?: Maybe<Scalars['String']>;
  bannerImage?: Maybe<Scalars['String']>;
};

export type HomeScreenNode = {
  __typename?: 'HomeScreenNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  platform: ScreenPlatform;
  scheduledContent?: Maybe<ScheduledContentNode>;
  screenSections: Array<Maybe<ScreenSectionNode>>;
};

export type InAppReviewFlowCompletedMutation = {
  __typename?: 'InAppReviewFlowCompletedMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum InAppReviewStore {
  AppStore = 'APP_STORE',
  PlayStore = 'PLAY_STORE'
}

export type InsuranceInput = {
  policyMemberId?: Maybe<Scalars['String']>;
  relationshipCode?: Maybe<Scalars['String']>;
  primaryFirstName?: Maybe<Scalars['String']>;
  primaryLastName?: Maybe<Scalars['String']>;
};

export type InsuranceMemberNode = {
  __typename?: 'InsuranceMemberNode';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender: Scalars['String'];
  dateOfBirth: Scalars['DateTime'];
  address: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
};

export type InsuranceNode = {
  __typename?: 'InsuranceNode';
  companyUuid?: Maybe<Scalars['UUID']>;
  policyNumber?: Maybe<Scalars['String']>;
  policyMemberId?: Maybe<Scalars['String']>;
  relationshipCode?: Maybe<Scalars['String']>;
  primaryFirstName?: Maybe<Scalars['String']>;
  primaryLastName?: Maybe<Scalars['String']>;
};

export enum IntakeFormCompletedOnPlatform {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type IntakeFormNode = {
  __typename?: 'IntakeFormNode';
  uuid: Scalars['UUID'];
  completedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  providerViewedAt?: Maybe<Scalars['DateTime']>;
  completedBy?: Maybe<MemberNode>;
  completedOnPlatform?: Maybe<IntakeFormCompletedOnPlatform>;
  exitedAt?: Maybe<Scalars['String']>;
  submitted: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  intakeFormQuestionResponses?: Maybe<Array<Maybe<IntakeFormQuestionResponseNode>>>;
};

export type IntakeFormQuestionResponseInputNode = {
  motivationToSeekCoaching?: Maybe<Scalars['String']>;
  outcomesToAchieveOne?: Maybe<Scalars['String']>;
  outcomesToAchieveTwo?: Maybe<Scalars['String']>;
  outcomesToAchieveThree?: Maybe<Scalars['String']>;
  currentPersonalAndProfessionalLife?: Maybe<Scalars['String']>;
  postSessionsPersonalAndProfessionalLife?: Maybe<Scalars['String']>;
  rankSupportAccountability?: Maybe<Scalars['Int']>;
  rankSupportBrainStorming?: Maybe<Scalars['Int']>;
  rankSupportExploringObstacles?: Maybe<Scalars['Int']>;
  rankSupportInsightIntoPotential?: Maybe<Scalars['Int']>;
  rankSupportVision?: Maybe<Scalars['Int']>;
  rankSupportEncouragement?: Maybe<Scalars['Int']>;
  howAreYouDerivingValue?: Maybe<Scalars['String']>;
  experiencedCoachingBefore?: Maybe<Array<Maybe<Scalars['String']>>>;
  anythingElse?: Maybe<Scalars['String']>;
};

export type IntakeFormQuestionResponseNode = {
  __typename?: 'IntakeFormQuestionResponseNode';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  intakeForm: IntakeFormNode;
  questionName?: Maybe<Scalars['String']>;
  questionResponseContent?: Maybe<Scalars['GenericScalar']>;
};

export type InternalLinkNode = Node & {
  __typename?: 'InternalLinkNode';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['UUID']>;
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  title: Scalars['String'];
  subtitle: Scalars['String'];
  image: Scalars['String'];
};


export type LanguageNode = {
  __typename?: 'LanguageNode';
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  code: Scalars['String'];
};

export type LinkCronofyCalendarMutation = {
  __typename?: 'LinkCronofyCalendarMutation';
  ok?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type ListHrAdminQueryOutput = UnknownCompanyError | HrAdminResult | PermissionDeniedError;

export type LogHrisConnectionInput = {
  appInfo: HrisAppInfo;
  authInfo: HrisAuthInfo;
};

export type LogHrisConnectionPayload = {
  __typename?: 'LogHRISConnectionPayload';
  connection?: Maybe<HrisConnectionNode>;
};

export type LogHrisConnectionResult = LogHrisConnectionPayload | PermissionDeniedError;

export type LookerSsoEmbedLink = {
  __typename?: 'LookerSsoEmbedLink';
  url?: Maybe<Scalars['String']>;
};

export type LookerSsoEmbedResult = LookerSsoEmbedLink | PermissionDeniedError | UnknownCompanyError | UnknownReportTypeError;

export type MarkCoachingVisitEnd = {
  __typename?: 'MarkCoachingVisitEnd';
  ok?: Maybe<Scalars['Boolean']>;
};

export type MarkCoachingVisitStart = {
  __typename?: 'MarkCoachingVisitStart';
  ok?: Maybe<Scalars['Boolean']>;
};

export type MatchedProvidersMutation = {
  __typename?: 'MatchedProvidersMutation';
  providersMatchedPreferences?: Maybe<Array<Maybe<CoachNode>>>;
  providersDidNotMatchPreferences?: Maybe<Array<Maybe<CoachNode>>>;
  allowsFiltering?: Maybe<Scalars['Boolean']>;
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
};

export type MeditationCategoryNode = {
  __typename?: 'MeditationCategoryNode';
  displayName: Scalars['String'];
  displayOrder: Scalars['Int'];
  meditations?: Maybe<Array<Maybe<MeditationNode>>>;
};


export type MeditationCategoryNodeMeditationsArgs = {
  languageCode?: Maybe<Scalars['String']>;
};

export type MeditationFinishMutation = {
  __typename?: 'MeditationFinishMutation';
  meditationProgress?: Maybe<MeditationProgressNode>;
};

export enum MeditationLanguageCode {
  EnUs = 'EN_US',
  Es = 'ES',
  FrCa = 'FR_CA',
  Fr = 'FR',
  Ko = 'KO',
  Ja = 'JA',
  ZhHans = 'ZH_HANS',
  De = 'DE',
  Hi = 'HI',
  Pt = 'PT'
}

export type MeditationLinkNode = Node & {
  __typename?: 'MeditationLinkNode';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['UUID']>;
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  meditation: MeditationNode;
};

export type MeditationNode = {
  __typename?: 'MeditationNode';
  id: Scalars['Int'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  category: Scalars['String'];
  meditationCategory?: Maybe<MeditationCategoryNode>;
  duration: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  image: Scalars['String'];
  audioFile: Scalars['String'];
  defaultOrdering?: Maybe<Scalars['Int']>;
  languageCode: MeditationLanguageCode;
  slug?: Maybe<Scalars['String']>;
  messageResources: Array<MessageResourceNode>;
  meditationProgress: Array<MeditationProgressNode>;
  meditationId: Scalars['Int'];
  progress?: Maybe<Array<Maybe<MeditationProgressNode>>>;
};

export type MeditationProgressNode = {
  __typename?: 'MeditationProgressNode';
  id: Scalars['ID'];
  owner: MemberNode;
  meditation?: Maybe<MeditationNode>;
  meditationName?: Maybe<Scalars['String']>;
  pillarWeek?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
};

export type MeditationStartMutation = {
  __typename?: 'MeditationStartMutation';
  meditationProgress?: Maybe<MeditationProgressNode>;
};

export enum MemberCarePreferenceFeelingsAboutTherapy {
  Committed = 'COMMITTED',
  Neutral = 'NEUTRAL',
  Hesitant = 'HESITANT'
}

export type MemberCarePreferenceNode = {
  __typename?: 'MemberCarePreferenceNode';
  id: Scalars['ID'];
  member: MemberNode;
  specialtiesSelected?: Maybe<Array<Maybe<Scalars['String']>>>;
  otherSpecialtiesFreeform?: Maybe<Scalars['String']>;
  feelingsAboutTherapy?: Maybe<MemberCarePreferenceFeelingsAboutTherapy>;
  createdAt: Scalars['DateTime'];
  isActive: Scalars['Boolean'];
  inactiveAt?: Maybe<Scalars['DateTime']>;
};

export type MemberFilterPreferenceNode = {
  __typename?: 'MemberFilterPreferenceNode';
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<MemberFilterPreferenceOptionNode>>>;
  title?: Maybe<Scalars['String']>;
};

export type MemberFilterPreferenceOptionNode = {
  __typename?: 'MemberFilterPreferenceOptionNode';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MemberInsuranceNode = {
  __typename?: 'MemberInsuranceNode';
  employerInsuranceId?: Maybe<Scalars['String']>;
  policyMemberId?: Maybe<Scalars['String']>;
  relationshipCode?: Maybe<Scalars['String']>;
  primaryFirstName?: Maybe<Scalars['String']>;
  primaryLastName?: Maybe<Scalars['String']>;
};

export type MemberNode = {
  __typename?: 'MemberNode';
  uuid: Scalars['UUID'];
  avatar?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  localTimezone?: Maybe<Scalars['String']>;
  credentials?: Maybe<Scalars['String']>;
  providerSpecialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  defaultVisitDuration: Scalars['Float'];
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  languagePreferences: Array<Maybe<Scalars['String']>>;
  goalInterests?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['Int']>;
  company?: Maybe<CompanyNode>;
  birthDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
  joinedAt: Scalars['Date'];
  phoneNumber?: Maybe<Scalars['String']>;
  role: AccountRole;
  oldEmailAddress?: Maybe<Scalars['String']>;
  newEmailAddressNotConfirmed?: Maybe<Scalars['String']>;
  emailConfirmed: Scalars['Boolean'];
  onboardingStatus?: Maybe<AccountOnboardingStatus>;
  availability?: Maybe<Array<Maybe<Scalars['String']>>>;
  registrationSource?: Maybe<Scalars['String']>;
  careRecommendations: Array<CareRecommendationNode>;
  surveys: Array<Who5SurveyNode>;
  age?: Maybe<Scalars['Int']>;
  parentUuid?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  isDependent?: Maybe<Scalars['Boolean']>;
  languagePreference?: Maybe<Scalars['String']>;
  lastActive?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  visitsRemaining?: Maybe<VisitsRemainingNode>;
  coachAssignments?: Maybe<Array<Maybe<CoachAssignmentNode>>>;
  lastLoggedInAt?: Maybe<Scalars['DateTime']>;
  lastMessageSentAt?: Maybe<Scalars['DateTime']>;
  lastVisitCompletedAt?: Maybe<Scalars['DateTime']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  companyAdditionalBenefits?: Maybe<Array<Maybe<CompanyAdditionalBenefitNode>>>;
  crisisProviderCompanyAssignments?: Maybe<Array<Maybe<CrisisProviderCompanyAssignmentNode>>>;
  crisisProviderCountryAssignments?: Maybe<Array<Maybe<CrisisProviderCountryAssignmentNode>>>;
  crisisProviders?: Maybe<Array<Maybe<CrisisProviderNode>>>;
  eligiblePersonEmail?: Maybe<Scalars['String']>;
  isActiveCobraRifMember?: Maybe<Scalars['Boolean']>;
  conversationsWithUnreadMessages?: Maybe<Array<Maybe<ConversationNode>>>;
  intakeForm?: Maybe<IntakeFormNode>;
};

export type MemberPageNode = {
  __typename?: 'MemberPageNode';
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  countFiltered?: Maybe<Scalars['Int']>;
  members?: Maybe<Array<Maybe<MemberNode>>>;
};

export type MemberPreferencesInput = {
  races?: Maybe<Array<Maybe<Scalars['String']>>>;
  showInternationalProviders?: Maybe<Scalars['Boolean']>;
};

export enum MessageKind {
  Coaching = 'COACHING',
  Therapy = 'THERAPY',
  Group = 'GROUP',
  LiveCoaching = 'LIVE_COACHING'
}

export type MessageNode = Node & {
  __typename?: 'MessageNode';
  uuid?: Maybe<Scalars['UUID']>;
  encryptedContent: Scalars['String'];
  sentAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  readAt?: Maybe<Scalars['DateTime']>;
  acknowledgedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  conversation?: Maybe<ConversationNode>;
  sender?: Maybe<MemberNode>;
  receiver?: Maybe<MemberNode>;
  kind: MessageKind;
  messageResources: Array<MessageResourceNode>;
  id: Scalars['ID'];
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
};

export type MessageNodeConnection = {
  __typename?: 'MessageNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<MessageNodeEdge>>;
};

export type MessageNodeEdge = {
  __typename?: 'MessageNodeEdge';
  node?: Maybe<MessageNode>;
  cursor: Scalars['String'];
};

export type MessageResourceInput = {
  uuid?: Maybe<Scalars['UUID']>;
  order?: Maybe<Scalars['Int']>;
  meditationId?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['Int']>;
};

export type MessageResourceNode = {
  __typename?: 'MessageResourceNode';
  uuid?: Maybe<Scalars['UUID']>;
  order: Scalars['Int'];
  program?: Maybe<ProgramNode>;
  meditation?: Maybe<MeditationNode>;
};

export type MultiselectConfig = {
  __typename?: 'MultiselectConfig';
  minSelectable?: Maybe<Scalars['Int']>;
  maxSelectable?: Maybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  overrideTranslation?: Maybe<OverrideTranslationResponseType>;
  createOrUpdateInsuranceMember?: Maybe<CreateOrUpdateInsuranceMemberResponse>;
  createOrUpdateInsurance?: Maybe<CreateOrUpdateInsuranceResponse>;
  createEligibilityCheck?: Maybe<CreateEligibilityCheckResponse>;
  disableHrAdmin?: Maybe<DisableHrAdminMutationResult>;
  logHrisConnection?: Maybe<LogHrisConnectionResult>;
  newMessage?: Maybe<NewMessageMutation>;
  newBulkMessage?: Maybe<NewBulkMessageMutation>;
  addNote?: Maybe<AddNoteMutation>;
  updateMessage?: Maybe<UpdateMessageMutation>;
  linkCronofyCalendar?: Maybe<LinkCronofyCalendarMutation>;
  updateAvailableHours?: Maybe<UpdateAvailableHoursMutation>;
  updateCalendar?: Maybe<UpdateCalendarMutation>;
  createEvent?: Maybe<CreateEventMutation>;
  cancelEvent?: Maybe<CancelEventMutation>;
  rescheduleEvent?: Maybe<RescheduleEventMutation>;
  recordPresenceChange?: Maybe<RecordPresenceChangeMutation>;
  deleteCalendarProfile?: Maybe<DeleteCalendarProfileMutation>;
  createVisit?: Maybe<CreateVisitMutation>;
  createProviderReview?: Maybe<CreateProviderReview>;
  updateVisit?: Maybe<UpdateVisitMutation>;
  updateProviderReview?: Maybe<UpdateProviderReview>;
  createOrUpdateProviderReview?: Maybe<CreateOrUpdateProviderReview>;
  recommendProviders?: Maybe<RecommendProvidersMutation>;
  chooseProvider?: Maybe<ChooseProviderMutation>;
  requestManualProviderMatch?: Maybe<RequestManualProviderMatchMutation>;
  matchedProviders?: Maybe<MatchedProvidersMutation>;
  timeToCareLabels?: Maybe<TimeToCareLabelMutation>;
  startProgram?: Maybe<ProgramStartMutation>;
  finishProgram?: Maybe<ProgramFinishMutation>;
  startPage?: Maybe<PageStartMutation>;
  finishPage?: Maybe<PageFinishMutation>;
  recordScheduledContentActivity?: Maybe<RecordScheduledContentActivityMutation>;
  reviewProgram?: Maybe<ReviewProgramMutation>;
  startMeditation?: Maybe<MeditationStartMutation>;
  finishMeditation?: Maybe<MeditationFinishMutation>;
  submitAssessments?: Maybe<SubmitAssessmentsMutation>;
  addMemberCarePreference?: Maybe<AddMemberCarePreferenceMutation>;
  selectTopicsOfFocus?: Maybe<SelectTopicsOfFocusMutation>;
  addSymptomsExperienced?: Maybe<AddSymptomsExperiencedMutation>;
  selectPrimaryFocus?: Maybe<SelectPrimaryFocusMutation>;
  addCoach?: Maybe<AddCoachMutation>;
  removeCoach?: Maybe<RemoveCoachMutation>;
  newCoachingVisit?: Maybe<CreateCoachingVisitMutation>;
  updateCoachingVisit?: Maybe<UpdateCoachingVisitMutation>;
  createNotification?: Maybe<CreateNotificationMutation>;
  createConversation?: Maybe<CreateConversationMutation>;
  updateConversation?: Maybe<UpdateConversationMutation>;
  /** @deprecated Please use CoachingVisitNode.zoomUrl instead */
  getVideoSession?: Maybe<GetOrCreateCoachingVisitVideoSessionMutation>;
  markCoachingVisitStart?: Maybe<MarkCoachingVisitStart>;
  markCoachingVisitEnd?: Maybe<MarkCoachingVisitEnd>;
  saveContentResponses?: Maybe<SaveContentResponsesMutation>;
  saveNewClientCapacity?: Maybe<SaveNewClientCapacityMutation>;
  saveRating?: Maybe<SaveRatingMutation>;
  createCoachingVisitMemberReview?: Maybe<CreateCoachingVisitMemberReviewMutation>;
  submitNps?: Maybe<SubmitNpsMutation>;
  submitFeatureReview?: Maybe<SubmitFeatureRecordReviewOutput>;
  inAppReviewFlowCompleted?: Maybe<InAppReviewFlowCompletedMutation>;
  startCareRecommendation?: Maybe<StartCareRecommendationMutation>;
  recommendCare?: Maybe<RecommendCareMutation>;
  acceptCareRecommendation?: Maybe<AcceptCareRecommendationMutation>;
  selectModality?: Maybe<SelectModalityMutation>;
  selectDifficulty?: Maybe<SelectDifficultyMutation>;
  startAssessmentFlow?: Maybe<StartAssessmentFlowMutation>;
  updateIntakeForm?: Maybe<UpdateIntakeFormMutation>;
  createTestMember?: Maybe<CreateTestMember>;
  deleteTestMember?: Maybe<DeleteTestMember>;
  circleRsvp?: Maybe<CircleRsvpResponsePayload>;
};


export type MutationOverrideTranslationArgs = {
  languageCode: Scalars['String'];
  translationKey: Scalars['String'];
  overrideText: Scalars['String'];
};


export type MutationCreateOrUpdateInsuranceMemberArgs = {
  input: CreateOrUpdateInsuranceMemberInput;
};


export type MutationCreateOrUpdateInsuranceArgs = {
  input: CreateOrUpdateInsuranceInput;
};


export type MutationDisableHrAdminArgs = {
  hrAdminUuid: Scalars['UUID'];
};


export type MutationLogHrisConnectionArgs = {
  connection: LogHrisConnectionInput;
};


export type MutationNewMessageArgs = {
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  clientsUuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  encryptedContent: Scalars['String'];
  kind?: Maybe<Scalars['String']>;
  messageResources?: Maybe<Array<Maybe<MessageResourceInput>>>;
  messageUuid?: Maybe<Scalars['UUID']>;
  senderUuid: Scalars['UUID'];
};


export type MutationNewBulkMessageArgs = {
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  clientsUuids: Array<Maybe<Scalars['UUID']>>;
  encryptedContent: Scalars['String'];
  kind?: Maybe<Scalars['String']>;
  messageResources?: Maybe<Array<Maybe<MessageResourceInput>>>;
  messageUuid?: Maybe<Scalars['UUID']>;
  senderUuid: Scalars['UUID'];
};


export type MutationAddNoteArgs = {
  coachAssignmentUuid: Scalars['UUID'];
  coachUuid: Scalars['UUID'];
  encryptedContent: Scalars['String'];
};


export type MutationUpdateMessageArgs = {
  acknowledgedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  encryptedContent?: Maybe<Scalars['String']>;
  messageUuid: Scalars['UUID'];
  readAt?: Maybe<Scalars['DateTime']>;
};


export type MutationLinkCronofyCalendarArgs = {
  code: Scalars['String'];
  redirectUri?: Maybe<Scalars['String']>;
};


export type MutationUpdateAvailableHoursArgs = {
  availableHours?: Maybe<Array<Maybe<AvailableHourInput>>>;
};


export type MutationUpdateCalendarArgs = {
  isActive: Scalars['Boolean'];
  isTarget: Scalars['Boolean'];
  uuid: Scalars['UUID'];
};


export type MutationCreateEventArgs = {
  coach?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  end: Scalars['DateTime'];
  ignoreWorkingHours?: Maybe<Scalars['Boolean']>;
  member?: Maybe<Scalars['UUID']>;
  start: Scalars['DateTime'];
  summary?: Maybe<Scalars['String']>;
};


export type MutationCancelEventArgs = {
  uuid: Scalars['UUID'];
};


export type MutationRescheduleEventArgs = {
  newStart: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};


export type MutationRecordPresenceChangeArgs = {
  coachUuid?: Maybe<Scalars['UUID']>;
  eventDatetime?: Maybe<Scalars['DateTime']>;
  onProviderDashboard?: Maybe<Scalars['Boolean']>;
  onlineForLiveCoaching?: Maybe<Scalars['Boolean']>;
  onlineForMyClients?: Maybe<Scalars['Boolean']>;
};


export type MutationDeleteCalendarProfileArgs = {
  id?: Maybe<Scalars['Int']>;
  profileId: Scalars['String'];
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationCreateVisitArgs = {
  actualDuration?: Maybe<Scalars['Int']>;
  coachAssignmentUuid: Scalars['UUID'];
  cptCode?: Maybe<Scalars['String']>;
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isTherapy?: Maybe<Scalars['Boolean']>;
  modalityType?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  primaryDiagnosisCode?: Maybe<Scalars['String']>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  secondaryDiagnosisCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<Scalars['String']>;
  visitInfo?: Maybe<Scalars['String']>;
};


export type MutationCreateProviderReviewArgs = {
  abilityToHelpClient: Scalars['Int'];
  clearPlanToWorkTowardGoals: Scalars['Int'];
  coachingVisitUuid: Scalars['UUID'];
  feedbackText?: Maybe<Scalars['String']>;
  workedOnAgreedUponGoals: Scalars['Int'];
};


export type MutationUpdateVisitArgs = {
  actualDuration?: Maybe<Scalars['Int']>;
  coachingVisitUuid: Scalars['UUID'];
  cptCode?: Maybe<Scalars['String']>;
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isTherapy?: Maybe<Scalars['Boolean']>;
  modalityType?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  primaryDiagnosisCode?: Maybe<Scalars['String']>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  secondaryDiagnosisCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<Scalars['String']>;
  visitInfo?: Maybe<Scalars['String']>;
};


export type MutationUpdateProviderReviewArgs = {
  abilityToHelpClient: Scalars['Int'];
  clearPlanToWorkTowardGoals: Scalars['Int'];
  coachingVisitUuid: Scalars['UUID'];
  feedbackText?: Maybe<Scalars['String']>;
  workedOnAgreedUponGoals: Scalars['Int'];
};


export type MutationCreateOrUpdateProviderReviewArgs = {
  abilityToHelpClient: Scalars['Int'];
  clearPlanToWorkTowardGoals: Scalars['Int'];
  coachingVisitUuid: Scalars['UUID'];
  feedbackText?: Maybe<Scalars['String']>;
  workedOnAgreedUponGoals: Scalars['Int'];
};


export type MutationRecommendProvidersArgs = {
  careRecommendationUuid: Scalars['UUID'];
};


export type MutationChooseProviderArgs = {
  providerUuid: Scalars['UUID'];
  uuid: Scalars['UUID'];
};


export type MutationRequestManualProviderMatchArgs = {
  preferences: Scalars['JSONString'];
  uuid: Scalars['UUID'];
};


export type MutationMatchedProvidersArgs = {
  careRecommendationUuid: Scalars['UUID'];
  pagination?: Maybe<PaginationInput>;
  preferences?: Maybe<MemberPreferencesInput>;
};


export type MutationTimeToCareLabelsArgs = {
  providersList: ProviderListInput;
};


export type MutationStartProgramArgs = {
  programName?: Maybe<Scalars['String']>;
  programUuid?: Maybe<Scalars['UUID']>;
};


export type MutationFinishProgramArgs = {
  programName?: Maybe<Scalars['String']>;
  programUuid?: Maybe<Scalars['UUID']>;
};


export type MutationStartPageArgs = {
  pageName: Scalars['String'];
  programName: Scalars['String'];
};


export type MutationFinishPageArgs = {
  input?: Maybe<Scalars['JSONString']>;
  pageName: Scalars['String'];
  programName: Scalars['String'];
};


export type MutationRecordScheduledContentActivityArgs = {
  activityType: ScheduledContentActivityType;
  scheduledContentUuid: Scalars['UUID'];
};


export type MutationReviewProgramArgs = {
  dislikedReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  likedReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  programUuid: Scalars['UUID'];
  rating?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
};


export type MutationStartMeditationArgs = {
  meditationName: Scalars['String'];
};


export type MutationFinishMeditationArgs = {
  meditationName: Scalars['String'];
};


export type MutationSubmitAssessmentsArgs = {
  assessmentFlowUuid?: Maybe<Scalars['UUID']>;
  careRecommendationUuid?: Maybe<Scalars['UUID']>;
  content: Scalars['JSONString'];
};


export type MutationAddMemberCarePreferenceArgs = {
  feelingsAboutTherapy?: Maybe<FeelingsAboutTherapyEnum>;
  otherSpecialtiesFreeform?: Maybe<Scalars['String']>;
  specialtiesSelected?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationSelectTopicsOfFocusArgs = {
  careRecommendationUuid: Scalars['UUID'];
  topicSelections?: Maybe<Array<Maybe<TopicInput>>>;
};


export type MutationAddSymptomsExperiencedArgs = {
  subtopicSelectionUuid: Scalars['UUID'];
  symptomsExperienced: Array<Maybe<Scalars['String']>>;
};


export type MutationSelectPrimaryFocusArgs = {
  subtopicSelectionUuid: Scalars['UUID'];
};


export type MutationAddCoachArgs = {
  coachUuid: Scalars['String'];
};


export type MutationRemoveCoachArgs = {
  coachUuid: Scalars['String'];
};


export type MutationNewCoachingVisitArgs = {
  actualDuration?: Maybe<Scalars['Int']>;
  coachAssignment: Scalars['UUID'];
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isTherapy?: Maybe<Scalars['Boolean']>;
  modalityType?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  reviews?: Maybe<Array<Maybe<ReviewInputNode>>>;
  scheduledDuration: Scalars['Int'];
  scheduledTime: Scalars['DateTime'];
  state?: Maybe<Scalars['String']>;
  visitInfo?: Maybe<Scalars['String']>;
};


export type MutationUpdateCoachingVisitArgs = {
  actualDuration?: Maybe<Scalars['Int']>;
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isTherapy?: Maybe<Scalars['Boolean']>;
  modalityType?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  reviews?: Maybe<Array<Maybe<ReviewInputNode>>>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  visitInfo?: Maybe<Scalars['String']>;
};


export type MutationCreateNotificationArgs = {
  type: Scalars['String'];
  receiverId: Scalars['UUID'];
  senderAction: Scalars['String'];
  senderId: Scalars['UUID'];
  senderType: Scalars['String'];
};


export type MutationCreateConversationArgs = {
  coachUuid: Scalars['UUID'];
  kind?: Maybe<ConversationKind>;
};


export type MutationUpdateConversationArgs = {
  active?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<ConversationKind>;
  uuid: Scalars['UUID'];
};


export type MutationGetVideoSessionArgs = {
  uuid: Scalars['UUID'];
};


export type MutationMarkCoachingVisitStartArgs = {
  uuid: Scalars['UUID'];
};


export type MutationMarkCoachingVisitEndArgs = {
  uuid: Scalars['UUID'];
};


export type MutationSaveContentResponsesArgs = {
  content: Scalars['JSONString'];
};


export type MutationSaveNewClientCapacityArgs = {
  providerSchedulingType?: Maybe<Scalars['String']>;
  updatedNewClientCapacity?: Maybe<Scalars['Int']>;
};


export type MutationSaveRatingArgs = {
  coachingVisitUuid: Scalars['UUID'];
  contentType?: Maybe<RatingContentTypeEnum>;
  feedbackText?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  reasons?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationCreateCoachingVisitMemberReviewArgs = {
  abilityToHelpMe?: Maybe<Scalars['Int']>;
  coachingVisitUuid: Scalars['UUID'];
  exitedAt?: Maybe<Scalars['String']>;
  feedbackText?: Maybe<Scalars['String']>;
  improvedMyWellBeing?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  whatCouldHaveBeenBetter?: Maybe<Array<Maybe<Scalars['String']>>>;
  whatYouLikedAboutYourCoach?: Maybe<Array<Maybe<Scalars['String']>>>;
  workedOnAgreedUponGoals?: Maybe<Scalars['Int']>;
};


export type MutationSubmitNpsArgs = {
  coachingVisitUuid?: Maybe<Scalars['UUID']>;
  feedbackText?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
};


export type MutationSubmitFeatureReviewArgs = {
  featureReview: FeatureRecordReviewInput;
};


export type MutationInAppReviewFlowCompletedArgs = {
  store: InAppReviewStore;
};


export type MutationStartCareRecommendationArgs = {
  onboarding?: Maybe<Scalars['Boolean']>;
};


export type MutationRecommendCareArgs = {
  modalityPreference?: Maybe<CareRecommendationModality>;
  uuid: Scalars['UUID'];
};


export type MutationAcceptCareRecommendationArgs = {
  outcome?: Maybe<CareOption>;
  uuid: Scalars['UUID'];
};


export type MutationSelectModalityArgs = {
  modalityPreference?: Maybe<CareRecommendationModality>;
  uuid: Scalars['UUID'];
};


export type MutationSelectDifficultyArgs = {
  difficultyAgreement: DifficultyAgreement;
  uuid: Scalars['UUID'];
};


export type MutationStartAssessmentFlowArgs = {
  associatedVisitUuid?: Maybe<Scalars['UUID']>;
  careRecommendationUuid?: Maybe<Scalars['UUID']>;
  flowType?: Maybe<Scalars['String']>;
};


export type MutationUpdateIntakeFormArgs = {
  exitedAt?: Maybe<Scalars['String']>;
  formInput?: Maybe<IntakeFormQuestionResponseInputNode>;
  intakeFormUuid: Scalars['UUID'];
  submitted?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateTestMemberArgs = {
  companyId: Scalars['Int'];
  dateOfBirth: Scalars['Date'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};


export type MutationDeleteTestMemberArgs = {
  uuid: Scalars['UUID'];
};


export type MutationCircleRsvpArgs = {
  sessionUuid: Scalars['UUID'];
  attendeeUuid?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  answers: Array<Maybe<CircleRsvpAnswerInput>>;
};

export type NewBulkMessageMutation = {
  __typename?: 'NewBulkMessageMutation';
  messagesList?: Maybe<Array<Maybe<MessageNode>>>;
};

export type NewMessageMutation = {
  __typename?: 'NewMessageMutation';
  message?: Maybe<MessageNode>;
  messagesList?: Maybe<Array<Maybe<MessageNode>>>;
};

export type Node = {
  id: Scalars['ID'];
};

export type NoteNode = {
  __typename?: 'NoteNode';
  uuid: Scalars['UUID'];
  encryptedContent: Scalars['String'];
  createdAt: Scalars['DateTime'];
  coachAssignment: CoachAssignmentNode;
};

export type OverrideTranslationResponseType = {
  __typename?: 'OverrideTranslationResponseType';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  translation?: Maybe<TranslationNode>;
};

export enum PageContentHorizontalAlignment {
  Start = 'START',
  Center = 'CENTER'
}

export enum PageContentVerticalAlignment {
  Top = 'TOP',
  Middle = 'MIDDLE'
}

export type PageFinishMutation = {
  __typename?: 'PageFinishMutation';
  pageProgress?: Maybe<PageProgressNode>;
};

export enum PageFirstBackgroundImagePosition {
  BottomLeft = 'BOTTOM_LEFT',
  BottomCenter = 'BOTTOM_CENTER',
  BottomRight = 'BOTTOM_RIGHT'
}

export enum PageImageSize {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
};

export type PageNode = {
  __typename?: 'PageNode';
  answerOptions?: Maybe<Scalars['JSONString']>;
  audioFile?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  contentHorizontalAlignment: PageContentHorizontalAlignment;
  contentVerticalAlignment: PageContentVerticalAlignment;
  createdAt: Scalars['DateTime'];
  currentPageProgress?: Maybe<PageProgressNode>;
  firstBackgroundImagePosition?: Maybe<PageFirstBackgroundImagePosition>;
  firstBackgroundImageUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imagePosition?: Maybe<Scalars['String']>;
  imageSize?: Maybe<PageImageSize>;
  multiselectConfig?: Maybe<Scalars['JSONString']>;
  name: Scalars['String'];
  number: Scalars['Int'];
  pageProgress: Array<PageProgressNode>;
  parsedAnswerOptions?: Maybe<Array<AnswerOption>>;
  parsedMultiselectConfig?: Maybe<MultiselectConfig>;
  program: ProgramNode;
  secondBackgroundImagePosition?: Maybe<PageSecondBackgroundImagePosition>;
  secondBackgroundImageUrl?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  videoContent?: Maybe<VideoContentNode>;
};

export type PageProgressNode = {
  __typename?: 'PageProgressNode';
  completedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  input: Scalars['JSONString'];
  page?: Maybe<PageNode>;
  parsedInput?: Maybe<Array<UserInput>>;
  programProgress: ProgramProgressNode;
  startedAt: Scalars['DateTime'];
};

export enum PageSecondBackgroundImagePosition {
  BottomLeft = 'BOTTOM_LEFT',
  BottomCenter = 'BOTTOM_CENTER',
  BottomRight = 'BOTTOM_RIGHT'
}

export type PageStartMutation = {
  __typename?: 'PageStartMutation';
  pageProgress?: Maybe<PageProgressNode>;
};

export type PaginationInput = {
  pageNumber?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type PermissionDeniedError = BaseError & {
  __typename?: 'PermissionDeniedError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type PossibleReportAndSectionType = AvailableReportType | UnavailableReportType | AvailableSectionType | UnavailableSectionType;

export type PossibleReportType = AvailableReportType | UnavailableReportType;

export enum ProgramAvailabilityState {
  Nobody = 'NOBODY',
  Reviewers = 'REVIEWERS',
  Everyone = 'EVERYONE'
}

export type ProgramFinishMutation = {
  __typename?: 'ProgramFinishMutation';
  programProgress?: Maybe<ProgramProgressNode>;
};

export type ProgramLinkNode = Node & {
  __typename?: 'ProgramLinkNode';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['UUID']>;
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  program: ProgramNode;
};

export type ProgramNode = {
  __typename?: 'ProgramNode';
  availabilityState: ProgramAvailabilityState;
  category?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['JSONString']>;
  defaultOrdering?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isProgramBuilder: Scalars['Boolean'];
  lockedBy?: Maybe<ProgramNode>;
  messageResources: Array<MessageResourceNode>;
  name: Scalars['String'];
  nextProgram?: Maybe<ProgramNode>;
  pages: Array<PageNode>;
  programId: Scalars['Int'];
  programProgress: Array<ProgramProgressNode>;
  showRatings?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type ProgramProgressNode = {
  __typename?: 'ProgramProgressNode';
  id: Scalars['ID'];
  owner: MemberNode;
  program?: Maybe<ProgramNode>;
  activated: Scalars['Boolean'];
  activatedAt?: Maybe<Scalars['DateTime']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  pageProgress: Array<PageProgressNode>;
};

export type ProgramStartMutation = {
  __typename?: 'ProgramStartMutation';
  programProgress?: Maybe<ProgramProgressNode>;
};

export type ProviderCertificationNode = {
  __typename?: 'ProviderCertificationNode';
  uuid: Scalars['UUID'];
  provider: MemberNode;
  certification: CertificationNode;
};

export type ProviderCoachingVisitNode = Node & {
  __typename?: 'ProviderCoachingVisitNode';
  uuid: Scalars['UUID'];
  coachAssignment?: Maybe<CoachAssignmentNode>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  actualDuration?: Maybe<Scalars['Int']>;
  scheduledTime: Scalars['DateTime'];
  isTherapy: Scalars['Boolean'];
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  visitInfo?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  state: CoachingVisitState;
  modalityType: CoachingVisitModalityType;
  videoService?: Maybe<Scalars['String']>;
  providerVideoStartTime?: Maybe<Scalars['DateTime']>;
  providerVideoEndTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  videoSessionUrl?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
  providerUuid?: Maybe<Scalars['String']>;
  previousProviderReview?: Maybe<CoachingVisitProviderReviewNode>;
};

export type ProviderCoachingVisitNodeConnection = {
  __typename?: 'ProviderCoachingVisitNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ProviderCoachingVisitNodeEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProviderCoachingVisitNodeEdge = {
  __typename?: 'ProviderCoachingVisitNodeEdge';
  node?: Maybe<ProviderCoachingVisitNode>;
  cursor: Scalars['String'];
};

export type ProviderLabelNode = {
  __typename?: 'ProviderLabelNode';
  providerUuid?: Maybe<Scalars['UUID']>;
  providerLabel?: Maybe<Scalars['String']>;
};

export type ProviderListInput = {
  providerUuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

export type ProviderMatchAttemptNode = {
  __typename?: 'ProviderMatchAttemptNode';
  uuid: Scalars['UUID'];
  careRecommendation?: Maybe<CareRecommendationNode>;
  startedAt: Scalars['DateTime'];
  recommendedAt?: Maybe<Scalars['DateTime']>;
  chosenAt?: Maybe<Scalars['DateTime']>;
  manualRequestAt?: Maybe<Scalars['DateTime']>;
  manualMatchCompletedAt?: Maybe<Scalars['DateTime']>;
  providerType: ProviderMatchAttemptProviderType;
  chosenOffer?: Maybe<ProviderOptionOffer>;
  coachAssignment?: Maybe<CoachAssignmentNode>;
  state: ProviderMatchAttemptState;
  providerOptionOffers: Array<ProviderOptionOffer>;
};

export enum ProviderMatchAttemptProviderType {
  Coach = 'COACH',
  Therapist = 'THERAPIST'
}

export enum ProviderMatchAttemptState {
  Started = 'STARTED',
  Recommended = 'RECOMMENDED',
  Chosen = 'CHOSEN',
  ManualRequest = 'MANUAL_REQUEST',
  ManualMatchCompleted = 'MANUAL_MATCH_COMPLETED'
}

export type ProviderOptionOffer = {
  __typename?: 'ProviderOptionOffer';
  uuid: Scalars['UUID'];
  member: MemberNode;
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
  order: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  provider?: Maybe<CoachNode>;
};

export type Query = {
  __typename?: 'Query';
  getTranslations: Array<Maybe<TranslationNode>>;
  getMember?: Maybe<InsuranceMemberNode>;
  getMemberInsurance?: Maybe<MemberInsuranceNode>;
  getCptCodes?: Maybe<Array<Maybe<CptCodeNode>>>;
  getDxCodes?: Maybe<Array<Maybe<DxCodeNode>>>;
  getRelationshipCodes?: Maybe<Array<Maybe<RelationshipCodeNode>>>;
  getEmployerInsurance?: Maybe<EmployerInsuranceNode>;
  getEligibilityForMember?: Maybe<Scalars['Boolean']>;
  getMyEligibilityStatus?: Maybe<Scalars['Boolean']>;
  conversations?: Maybe<ConversationNodeConnection>;
  conversation?: Maybe<ConversationNode>;
  messages?: Maybe<MessageNodeConnection>;
  availableHours?: Maybe<Array<Maybe<AvailableHourNode>>>;
  calendarAuthLink?: Maybe<CalendarAuthLinkNode>;
  calendarProfiles?: Maybe<Array<Maybe<CalendarProfileNode>>>;
  coachAvailability?: Maybe<Array<Maybe<AvailablePeriodNode>>>;
  providerAvailability?: Maybe<Array<Maybe<AvailablePeriodNode>>>;
  clients?: Maybe<ClientSummaryNodeConnection>;
  companies?: Maybe<Array<Maybe<CompanyDropdownNode>>>;
  myClients?: Maybe<MemberPageNode>;
  hasCalendarSetup?: Maybe<Scalars['Boolean']>;
  providerCoachingVisits?: Maybe<ProviderCoachingVisitNodeConnection>;
  providerIntakeForms?: Maybe<Array<Maybe<IntakeFormNode>>>;
  providerIntakeForm?: Maybe<IntakeFormNode>;
  program?: Maybe<ProgramNode>;
  programBySlug?: Maybe<ProgramNode>;
  screens?: Maybe<Array<Maybe<ScreenNode>>>;
  homeScreen?: Maybe<HomeScreenNode>;
  contentCollection?: Maybe<ContentCollectionNode>;
  programs?: Maybe<Array<Maybe<ProgramNode>>>;
  programProgress?: Maybe<Array<Maybe<ProgramProgressNode>>>;
  pageProgress?: Maybe<Array<Maybe<PageProgressNode>>>;
  pages?: Maybe<Array<Maybe<PageNode>>>;
  scheduledContentActivity?: Maybe<ScheduledContentActivitySummaryNode>;
  scheduledContent?: Maybe<ScheduledContentNode>;
  assessment?: Maybe<AssessmentNode>;
  assessments?: Maybe<Array<Maybe<AssessmentNode>>>;
  assessmentQuestion?: Maybe<AssessmentQuestionNode>;
  meditation?: Maybe<MeditationNode>;
  meditationBySlug?: Maybe<MeditationNode>;
  meditations?: Maybe<Array<Maybe<MeditationNode>>>;
  meditationCategories?: Maybe<Array<Maybe<MeditationCategoryNode>>>;
  meditationProgress?: Maybe<Array<Maybe<MeditationProgressNode>>>;
  listHrAdmins?: Maybe<ListHrAdminQueryOutput>;
  hrMessages?: Maybe<HrMessagesResult>;
  isHrAdmin?: Maybe<Scalars['Boolean']>;
  lookerSsoEmbed?: Maybe<LookerSsoEmbedResult>;
  getAllReportsAndSections?: Maybe<GetAllReportsAndSectionsResult>;
  topicsOfFocus?: Maybe<Array<Maybe<TopicOfFocusNode>>>;
  memberCarePreferences?: Maybe<Array<Maybe<MemberCarePreferenceNode>>>;
  coachAssignments?: Maybe<Array<Maybe<CoachAssignmentNode>>>;
  coaches?: Maybe<Array<Maybe<CoachNode>>>;
  coachingVisits?: Maybe<Array<Maybe<CoachingVisitNode>>>;
  lastInvoicedCoachingVisit?: Maybe<CoachingVisitNode>;
  contentResponses?: Maybe<ContentResponsesNode>;
  me?: Maybe<MemberNode>;
  member?: Maybe<MemberNode>;
  coachingVisit?: Maybe<CoachingVisitNode>;
  companyAdditionalBenefits?: Maybe<Array<Maybe<CompanyAdditionalBenefitNode>>>;
  crisisProviderCompanyAssignments?: Maybe<Array<Maybe<CrisisProviderCompanyAssignmentNode>>>;
  crisisProviderCountryAssignments?: Maybe<Array<Maybe<CrisisProviderCountryAssignmentNode>>>;
  crisisProviders?: Maybe<Array<Maybe<CrisisProviderNode>>>;
  groupPractice?: Maybe<GroupPracticeNode>;
  shouldShowNpsQuestion?: Maybe<Scalars['Boolean']>;
  shouldShowInAppReviewFlow?: Maybe<Scalars['Boolean']>;
  memberFilterPreferences?: Maybe<Array<Maybe<MemberFilterPreferenceNode>>>;
  intakeForm?: Maybe<IntakeFormNode>;
  circleSeriesCollection: CircleSeriesCollection;
  circleSeries?: Maybe<CircleSeriesNode>;
  circleFacilitator?: Maybe<CircleFacilitatorNode>;
  circleTopicConnection: CircleTopicConnection;
  circleTopic?: Maybe<CircleTopicNode>;
  circleSessionConnection: CircleSessionConnection;
  circleSession?: Maybe<CircleSessionNode>;
};


export type QueryGetTranslationsArgs = {
  languageCode: Scalars['String'];
  collectionName?: Maybe<Scalars['String']>;
};


export type QueryGetMemberArgs = {
  accountUuid: Scalars['UUID'];
};


export type QueryGetEmployerInsuranceArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryGetEligibilityForMemberArgs = {
  memberUuid: Scalars['UUID'];
};


export type QueryConversationsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['UUID']>;
  active?: Maybe<Scalars['Boolean']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  memberName?: Maybe<Scalars['String']>;
  memberEmail?: Maybe<Scalars['String']>;
  memberCompany?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryConversationArgs = {
  uuid: Scalars['UUID'];
};


export type QueryMessagesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['UUID']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  senderUuid?: Maybe<Scalars['UUID']>;
  receiverUuid?: Maybe<Scalars['UUID']>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryCalendarAuthLinkArgs = {
  redirectUri?: Maybe<Scalars['String']>;
};


export type QueryCalendarProfilesArgs = {
  sync?: Maybe<Scalars['Boolean']>;
};


export type QueryCoachAvailabilityArgs = {
  coach: Scalars['UUID'];
  ignoreWorkingHours?: Maybe<Scalars['Boolean']>;
};


export type QueryProviderAvailabilityArgs = {
  providerUuid: Scalars['UUID'];
  memberUuid?: Maybe<Scalars['UUID']>;
  ignoreWorkingHours?: Maybe<Scalars['Boolean']>;
};


export type QueryClientsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  appInstalled?: Maybe<Scalars['Boolean']>;
  coachHasSentMessage?: Maybe<Scalars['Boolean']>;
  companyName?: Maybe<Scalars['String']>;
  isMatched?: Maybe<Scalars['Boolean']>;
  lastInteraction?: Maybe<Scalars['DateTime']>;
  lastVisit?: Maybe<Scalars['DateTime']>;
  lastWho5Date?: Maybe<Scalars['String']>;
  matchDate?: Maybe<Scalars['DateTime']>;
  memberEmail?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  nextVisit?: Maybe<Scalars['DateTime']>;
  visitsCovered?: Maybe<Scalars['Int']>;
  companies?: Maybe<Scalars['String']>;
  hasRemainingSessions?: Maybe<Scalars['Boolean']>;
  hasUpcomingBooking?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  matchStatus?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryMyClientsArgs = {
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  matched?: Maybe<Scalars['Boolean']>;
  activeAfter?: Maybe<Scalars['DateTime']>;
  loggedInAfter?: Maybe<Scalars['DateTime']>;
  newMatches?: Maybe<Scalars['Boolean']>;
};


export type QueryHasCalendarSetupArgs = {
  coach: Scalars['UUID'];
};


export type QueryProviderCoachingVisitsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  scheduledTimeBefore?: Maybe<Scalars['DateTime']>;
  scheduledTimeAfter?: Maybe<Scalars['DateTime']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryProviderIntakeFormArgs = {
  intakeFormUuid: Scalars['UUID'];
};


export type QueryProgramArgs = {
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryProgramBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryScreensArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryHomeScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryContentCollectionArgs = {
  uuid?: Maybe<Scalars['UUID']>;
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryScheduledContentArgs = {
  contentType?: Maybe<ScheduledContentType>;
  forTime?: Maybe<Scalars['DateTime']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryAssessmentArgs = {
  name?: Maybe<Scalars['String']>;
};


export type QueryMeditationArgs = {
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryMeditationBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryMeditationsArgs = {
  languageCode?: Maybe<Scalars['String']>;
};


export type QueryListHrAdminsArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryHrMessagesArgs = {
  includeSeen?: Maybe<Scalars['Boolean']>;
};


export type QueryLookerSsoEmbedArgs = {
  reportType?: Maybe<ReportTypeEnum>;
};


export type QueryCoachAssignmentsArgs = {
  coachAssignmentUuid?: Maybe<Scalars['String']>;
  coachUuid?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
};


export type QueryCoachesArgs = {
  providerType?: Maybe<Scalars['String']>;
  pageSize?: Maybe<Scalars['Int']>;
  pageNumber?: Maybe<Scalars['Int']>;
};


export type QueryMemberArgs = {
  uuid: Scalars['UUID'];
};


export type QueryCoachingVisitArgs = {
  uuid: Scalars['UUID'];
};


export type QueryShouldShowNpsQuestionArgs = {
  coachingVisitUuid: Scalars['UUID'];
};


export type QueryShouldShowInAppReviewFlowArgs = {
  store: InAppReviewStore;
  npsScore?: Maybe<Scalars['Int']>;
};


export type QueryIntakeFormArgs = {
  coachAssignmentUuid?: Maybe<Scalars['UUID']>;
  intakeFormUuid?: Maybe<Scalars['UUID']>;
};


export type QueryCircleSeriesArgs = {
  id: Scalars['ID'];
};


export type QueryCircleFacilitatorArgs = {
  id: Scalars['ID'];
};


export type QueryCircleTopicConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  seriesId: Scalars['ID'];
};


export type QueryCircleTopicArgs = {
  id: Scalars['ID'];
};


export type QueryCircleSessionConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  topicId: Scalars['ID'];
  beforeDateTime?: Maybe<Scalars['DateTime']>;
  afterDateTime?: Maybe<Scalars['DateTime']>;
};


export type QueryCircleSessionArgs = {
  id: Scalars['ID'];
};

export enum RatingContentTypeEnum {
  Visit = 'VISIT',
  Program = 'PROGRAM',
  Meditation = 'MEDITATION'
}

export type RatingNode = {
  __typename?: 'RatingNode';
  createdAt: Scalars['DateTime'];
  coachingVisit: CoachingVisitNode;
  rating: Scalars['Int'];
  reasons: Array<Maybe<Scalars['String']>>;
  feedbackText?: Maybe<Scalars['String']>;
};

export type RecommendCareMutation = {
  __typename?: 'RecommendCareMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type RecommendProvidersMutation = {
  __typename?: 'RecommendProvidersMutation';
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
};

export type RecordPresenceChangeMutation = {
  __typename?: 'RecordPresenceChangeMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RecordScheduledContentActivityMutation = {
  __typename?: 'RecordScheduledContentActivityMutation';
  activitySummary?: Maybe<ScheduledContentActivitySummaryNode>;
};

export type RelationshipCodeNode = {
  __typename?: 'RelationshipCodeNode';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type RemoveCoachMutation = {
  __typename?: 'RemoveCoachMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export enum ReportTypeEnum {
  Darjeeling = 'DARJEELING',
  Matcha = 'MATCHA',
  OolongPhoenix = 'OOLONG_PHOENIX',
  OolongHighMountain = 'OOLONG_HIGH_MOUNTAIN',
  BenefitSnapshot = 'BENEFIT_SNAPSHOT',
  EngagementAndRegistration = 'ENGAGEMENT_AND_REGISTRATION',
  HealthAndWellbeingOverview = 'HEALTH_AND_WELLBEING_OVERVIEW',
  HealthAndWellbeingAreasOfInterest = 'HEALTH_AND_WELLBEING_AREAS_OF_INTEREST',
  UtilizationOneOnOneCare = 'UTILIZATION_ONE_ON_ONE_CARE',
  UtilizationCircles = 'UTILIZATION_CIRCLES',
  UtilizationDigitalContent = 'UTILIZATION_DIGITAL_CONTENT',
  InternalBenchmarkingDash = 'INTERNAL_BENCHMARKING_DASH',
  InternalQbrDash = 'INTERNAL_QBR_DASH',
  InternalRoiDash = 'INTERNAL_ROI_DASH',
  InternalOutcome = 'INTERNAL_OUTCOME',
  InternalAccessStats = 'INTERNAL_ACCESS_STATS'
}

export type RequestManualProviderMatchMutation = {
  __typename?: 'RequestManualProviderMatchMutation';
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
};

export type RescheduleEventMutation = {
  __typename?: 'RescheduleEventMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ReviewInputNode = {
  reviewId?: Maybe<Scalars['Int']>;
  rating: Scalars['Int'];
  reason: Scalars['String'];
  feedbackText?: Maybe<Scalars['String']>;
};

export type ReviewNode = {
  __typename?: 'ReviewNode';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  reviewer: MemberNode;
  targetType: Scalars['String'];
  targetId: Scalars['Int'];
  rating: Scalars['Int'];
  reason: Scalars['String'];
  feedbackText?: Maybe<Scalars['String']>;
  coachingVisitProviderReviews?: Maybe<CoachingVisitProviderReviewNode>;
  reviewId: Scalars['Int'];
};

export type ReviewProgramMutation = {
  __typename?: 'ReviewProgramMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SaveContentResponsesMutation = {
  __typename?: 'SaveContentResponsesMutation';
  updatedContentResponses?: Maybe<ContentResponsesNode>;
};

export type SaveNewClientCapacityMutation = {
  __typename?: 'SaveNewClientCapacityMutation';
  newClientCapacity?: Maybe<Scalars['Int']>;
  providerSchedulingType?: Maybe<Scalars['String']>;
};

export type SaveRatingMutation = {
  __typename?: 'SaveRatingMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum ScheduledContentActivityActivityType {
  Viewed = 'VIEWED',
  CtaClicked = 'CTA_CLICKED',
  Completed = 'COMPLETED',
  Liked = 'LIKED',
  Disliked = 'DISLIKED'
}

export type ScheduledContentActivityNode = {
  __typename?: 'ScheduledContentActivityNode';
  scheduledContent: ScheduledContentNode;
  activityType: ScheduledContentActivityActivityType;
  timestamp: Scalars['DateTime'];
};

export type ScheduledContentActivitySummaryNode = {
  __typename?: 'ScheduledContentActivitySummaryNode';
  myActivity?: Maybe<Array<Maybe<ScheduledContentActivityNode>>>;
  viewedCount?: Maybe<Scalars['Int']>;
  ctaClickedCount?: Maybe<Scalars['Int']>;
  completedCount?: Maybe<Scalars['Int']>;
  likedCount?: Maybe<Scalars['Int']>;
  dislikedCount?: Maybe<Scalars['Int']>;
};

export enum ScheduledContentActivityType {
  Viewed = 'VIEWED',
  CtaClicked = 'CTA_CLICKED',
  Completed = 'COMPLETED',
  Liked = 'LIKED',
  Disliked = 'DISLIKED'
}

export enum ScheduledContentContentType {
  DailyPause = 'DAILY_PAUSE'
}

export type ScheduledContentLinkNode = {
  __typename?: 'ScheduledContentLinkNode';
  webValue?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  mobileValue: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  scheduledContent: ScheduledContentNode;
  isCta: Scalars['Boolean'];
  linkType: ContentCollectionLinkLinkType;
};

export type ScheduledContentNode = {
  __typename?: 'ScheduledContentNode';
  uuid: Scalars['UUID'];
  contentType: ScheduledContentContentType;
  startTime: Scalars['DateTime'];
  bannerTitle: Scalars['String'];
  bannerContent: Scalars['String'];
  bannerCtaText: Scalars['String'];
  bannerImage?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  accentColor?: Maybe<Scalars['String']>;
  titleColor?: Maybe<Scalars['String']>;
  fullContent: Scalars['String'];
  linkHeader?: Maybe<Scalars['String']>;
  scheduledContentLinks: Array<ScheduledContentLinkNode>;
  myActivity?: Maybe<Array<Maybe<ScheduledContentActivityNode>>>;
  duration?: Maybe<Scalars['Int']>;
};

export enum ScheduledContentType {
  DailyPause = 'DAILY_PAUSE'
}

export type ScreenLinkNode = Node & {
  __typename?: 'ScreenLinkNode';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['UUID']>;
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  screen: ScreenNode;
};

export type ScreenNode = HomeScreenNode;

export enum ScreenPlatform {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type ScreenSectionNode = {
  __typename?: 'ScreenSectionNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  index: Scalars['Int'];
  renderComponent?: Maybe<ContentCollectionRenderComponent>;
  minimumMobileVersion: Scalars['String'];
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  contentCollectionLinks: Array<ContentLinkNode>;
  ctaLink?: Maybe<ContentLinkNode>;
};

export type SelectDifficultyMutation = {
  __typename?: 'SelectDifficultyMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type SelectModalityMutation = {
  __typename?: 'SelectModalityMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type SelectPrimaryFocusMutation = {
  __typename?: 'SelectPrimaryFocusMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SelectTopicsOfFocusMutation = {
  __typename?: 'SelectTopicsOfFocusMutation';
  topicSelections?: Maybe<Array<Maybe<TopicSelectionNode>>>;
};

export type StartAssessmentFlowMutation = {
  __typename?: 'StartAssessmentFlowMutation';
  assessmentFlow?: Maybe<AssessmentFlowNode>;
};

export type StartCareRecommendationMutation = {
  __typename?: 'StartCareRecommendationMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type SubmitAssessmentsMutation = {
  __typename?: 'SubmitAssessmentsMutation';
  assessment?: Maybe<AssessmentNode>;
  createdContentResponses?: Maybe<Array<Maybe<ContentResponsesNode>>>;
  score?: Maybe<Scalars['Int']>;
};

export type SubmitFeatureRecordReviewOutput = FeatureRecordReviewResponse | FeatureRecordDoesNotExist;

export type SubmitNpsMutation = {
  __typename?: 'SubmitNpsMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SubtopicOfFocusNode = {
  __typename?: 'SubtopicOfFocusNode';
  topicOfFocus: TopicOfFocusNode;
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  symptoms: Array<Maybe<Scalars['String']>>;
  subtopicSymptoms: Array<SubtopicOfFocusSymptomNode>;
};

export type SubtopicOfFocusSymptomNode = {
  __typename?: 'SubtopicOfFocusSymptomNode';
  uuid: Scalars['UUID'];
  nameEnUs?: Maybe<Scalars['String']>;
  nameEs?: Maybe<Scalars['String']>;
  nameFrCa?: Maybe<Scalars['String']>;
  nameFr?: Maybe<Scalars['String']>;
  nameKo?: Maybe<Scalars['String']>;
  nameJa?: Maybe<Scalars['String']>;
  nameZhHans?: Maybe<Scalars['String']>;
  nameDe?: Maybe<Scalars['String']>;
  nameHi?: Maybe<Scalars['String']>;
  namePt?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  displayOrder: Scalars['Int'];
};

export type SubtopicSelectionNode = {
  __typename?: 'SubtopicSelectionNode';
  subtopicOfFocus: SubtopicOfFocusNode;
  topicSelection: TopicSelectionNode;
  uuid: Scalars['UUID'];
  symptomsExperienced: Array<Maybe<Scalars['String']>>;
};

export type TimeToCareLabelMutation = {
  __typename?: 'TimeToCareLabelMutation';
  providersWithTtcLabels?: Maybe<Array<Maybe<ProviderLabelNode>>>;
};

export type TopicInput = {
  topicUuid: Scalars['UUID'];
  subtopicUuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

export type TopicOfFocusNode = {
  __typename?: 'TopicOfFocusNode';
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  displayOrder: Scalars['Int'];
  image: Scalars['String'];
  subtopicsOfFocus: Array<SubtopicOfFocusNode>;
};

export type TopicSelectionNode = {
  __typename?: 'TopicSelectionNode';
  topicOfFocus: TopicOfFocusNode;
  careRecommendation: CareRecommendationNode;
  uuid: Scalars['UUID'];
  subtopicSelections: Array<SubtopicSelectionNode>;
};

export type TranslationCollectionNode = {
  __typename?: 'TranslationCollectionNode';
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  translations?: Maybe<Array<Maybe<TranslationNode>>>;
};

export type TranslationKeyNode = {
  __typename?: 'TranslationKeyNode';
  uuid: Scalars['UUID'];
  key: Scalars['String'];
  defaultTranslation: Scalars['String'];
};

export type TranslationNode = {
  __typename?: 'TranslationNode';
  uuid: Scalars['UUID'];
  language: LanguageNode;
  collections: Array<Maybe<TranslationCollectionNode>>;
  translationKey: TranslationKeyNode;
  translatedText: Scalars['String'];
};


export type UnavailableReportType = {
  __typename?: 'UnavailableReportType';
  reportOrSectionEnum?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  mainMessage?: Maybe<Scalars['String']>;
  subMessage?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
};

export type UnavailableSectionType = {
  __typename?: 'UnavailableSectionType';
  reportOrSectionEnum?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  mainMessage?: Maybe<Scalars['String']>;
  subMessage?: Maybe<Scalars['String']>;
};

export type UnknownCompanyError = BaseError & {
  __typename?: 'UnknownCompanyError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type UnknownHrAdminError = BaseError & {
  __typename?: 'UnknownHRAdminError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type UnknownReportTypeError = BaseError & {
  __typename?: 'UnknownReportTypeError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type UpdateAvailableHoursMutation = {
  __typename?: 'UpdateAvailableHoursMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateCalendarMutation = {
  __typename?: 'UpdateCalendarMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateCoachingVisitMutation = {
  __typename?: 'UpdateCoachingVisitMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateConversationMutation = {
  __typename?: 'UpdateConversationMutation';
  conversation?: Maybe<ConversationNode>;
};

export type UpdateIntakeFormMutation = {
  __typename?: 'UpdateIntakeFormMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateMessageMutation = {
  __typename?: 'UpdateMessageMutation';
  ok?: Maybe<Scalars['Boolean']>;
  message?: Maybe<MessageNode>;
};

export type UpdateProviderReview = {
  __typename?: 'UpdateProviderReview';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateVisitMutation = {
  __typename?: 'UpdateVisitMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UserInput = {
  __typename?: 'UserInput';
  optionValue?: Maybe<Scalars['String']>;
  textValue?: Maybe<Scalars['String']>;
};

export type VideoContentNode = {
  __typename?: 'VideoContentNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  title: Scalars['String'];
  poster?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  textTrack?: Maybe<Scalars['String']>;
};

export type VideoSessionNode = {
  __typename?: 'VideoSessionNode';
  sessionId?: Maybe<Scalars['String']>;
  sessionToken?: Maybe<Scalars['String']>;
  apiKey?: Maybe<Scalars['String']>;
  coachingVisit?: Maybe<CoachingVisitNode>;
};

export type VisitsRemainingNode = {
  __typename?: 'VisitsRemainingNode';
  coachingVisitsRemaining?: Maybe<Scalars['Int']>;
  therapyVisitsRemaining?: Maybe<Scalars['Int']>;
};

export type Who5SurveyNode = {
  __typename?: 'Who5SurveyNode';
  id: Scalars['ID'];
  who5Goodspirits: Scalars['Int'];
  who5Calmrelaxed: Scalars['Int'];
  who5Activevigorous: Scalars['Int'];
  who5Freshrested: Scalars['Int'];
  who5Interestme: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  who5Althoughsick?: Maybe<Scalars['Int']>;
  who5Stickness?: Maybe<Scalars['Int']>;
  who5Burnedout?: Maybe<Scalars['Int']>;
  who5Recommendcompany?: Maybe<Scalars['Int']>;
  owner: MemberNode;
  score?: Maybe<Scalars['Int']>;
};
